import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientesService } from '../../../pages/administracao/clientes/clientes/clientes.service';
import { BaseService } from '../../../pages/administracao/infra/servidores/base.service';
import { ToastService } from '../../../services/toast.service';
import { Base } from '../../../types/Base.type';
import { ClienteBasicoResponse } from '../../../types/ClienteBasicoResponse.type';
import { Servidor } from '../../../types/Servidor.type';

@Component({
  selector: 'app-novabase',
  templateUrl: './novabase.component.html',
  styleUrl: './novabase.component.css'
})
export class NovabaseComponent {

  @Input() servidor: Servidor = {} as Servidor;
  @Output() public fechar = new EventEmitter();

  constructor(private clienteService: ClientesService, private baseService: BaseService, private toastService: ToastService) {
    this.getClientes()
  }

  @Input() baseDialog: boolean = false;
  base: Base = {} as Base;
  enviadoBase: boolean = false;

  clientes!: ClienteBasicoResponse[];

  clienteSelecionado!: ClienteBasicoResponse;

  salvarBaseNova(){
    this.enviadoBase = true;

    if(this.base.nome?.trim() && this.clienteSelecionado.id != undefined && this.base.usuario?.trim() && this.base.senha?.trim()){
      this.base.clienteId = this.clienteSelecionado.id;
      this.base.servidorId = this.servidor.id;

      this.baseService.post(this.base).subscribe({
        next: () => {
          this.toastService.sucesso("Sucesso", "Base criada com sucesso");
          this.baseDialog = false;
          this.base = {} as Base;
          this.servidor = {} as Servidor;

          this.escondeDialogBase();
        },
        error: (value) => {
          this.toastService.erro("Erro", "Erro ao criar: " + value.error);
        }
      })

      
    }

    
  }

  getClientes(){
    this.clienteService.getBasico().subscribe((data) => {
      this.clientes = data;
    })
  }

  escondeDialogBase(){
    this.baseDialog = false;
    this.enviadoBase = false;
    this.servidor = {} as Servidor;
    this.clienteSelecionado = {} as ClienteBasicoResponse;
    this.base = {} as Base;

    this.fechar.emit();
   }

}
